import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import axiosInstance from '../config/AxiosConfig';
import { PoiListResp } from 'domain/payload/response/poi/PoiListResp';
import { PoiCreateReq } from 'domain/payload/request/poi/PoiCreateReq';
import { PoiDetailResp } from 'domain/payload/response/poi/PoiDetailResp';
import { PoiUpdateReq } from 'domain/payload/request/poi/PoiUpdateReq';
import { PoiConfigResp } from 'domain/payload/response/poi/PoiConfigResp';

const PoiService = () => {
  const poiList = async (
    token: string,
    search: string | null,
    page: number | null,
    size: number | null
  ): Promise<BaseResponse<PoiListResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/poi/list`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          search: search,
          page: page,
          size: size
        }
      });

      return response.data;

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const poiDetail = async (
    token: string,
    id: string
  ): Promise<BaseResponse<PoiDetailResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/poi/detail`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          id
        }
      });

      return response.data;
    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const poiConfig = async (
    token: string
  ): Promise<BaseResponse<PoiConfigResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/poi/config`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data;
    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const poiCreate = async (
    token: string,
    request: PoiCreateReq
      ): Promise<BaseResponse<PoiDetailResp>> => { 
    try {
      const response = await axiosInstance.post(`/v1/legacy/cms/poi/create`, request, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data;
    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const poiUpdate = async (
    token: string,
    request: PoiUpdateReq
  ): Promise<BaseResponse<PoiDetailResp>> => {
    try {
      const response = await axiosInstance.put(`/v1/legacy/cms/poi/update`, request, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data;
    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const poiDelete = async (
    token: string,
    id: string
  ): Promise<BaseResponse<any>> => {
    try {
      const response = await axiosInstance.delete(`/v1/legacy/cms/poi/delete?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data;
    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  return { poiList, poiCreate, poiDetail, poiConfig, poiUpdate, poiDelete };
};

export default PoiService;